export const PRODUCTS = [
    "motor_private",
    "pi",
    "individual_medical",
    "group_medical",
];
export const PRODUCT_LABELS = {
    motor_private: "ICPAK Private Motor",
    pi: "ICPAK Professional Indemnity",
    individual_medical: "ICPAK Individual / Family Medical",
    group_medical: "ICPAK Group / SME Medical",
};
export const REFERENCE_PREFIX = {
    motor_private: "MOT",
    pi: "PI",
    individual_medical: "IMD",
    group_medical: "GMD",
};
export const SUBMISSION_STATUSES = [
    "quote",
    "submitted",
    "payment_pending",
    "payment_confirmed",
    "docs_received",
    "issued",
    "cancelled",
];
/** Max file size for uploads, in bytes (5 MB). */
export const MAX_UPLOAD_BYTES = 5 * 1024 * 1024;
export const ALLOWED_MIME = [
    "application/pdf",
    "image/jpeg",
    "image/png",
];
